import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd2df32e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "banner"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "form-container" }
const _hoisted_4 = { class: "title top-title" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "站外发帖截图", -1))
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 图片要求与示例 ")
const _hoisted_7 = { class: "upload-container" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "upload-text" }, "点击上传", -1))
const _hoisted_9 = ["src"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createTextVNode("重新上传")
const _hoisted_12 = { class: "description" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "站外发帖链接", -1))
const _hoisted_14 = { class: "button-container" }

import { useTitle } from "@/hooks/useTitle";
import { computed, onMounted, onUnmounted, ref } from "vue";
import { DuButton, DuIcon, DuTextarea, DuTheme, DuImage } from "dangoui";
import jb from "@frontend/effuse";
import axios from "axios";
import {
  closeToast,
  showLoadingToast,
  showToast,
  showImagePreview,
} from "vant";

import LotteryApi from "@/apis/lottery";
import router from "@/router";
import { ossUpload } from "@/apis/upload";
import dayjs from "dayjs";

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const reachedDeadline = ref(false);
const loading = ref(false);
const { setTitle } = useTitle();

const state = ref<{
  voucher: string;
  text: string;
  inTroductionHtmlLink: string;
  detail: any;
}>({
  voucher: "",
  text: "",
  inTroductionHtmlLink: "",
  detail: null,
});

const voucherDesc = ref("");

const lastSubmitedTime = computed(() => {
  return state.value.detail?.voucher?.voucherUploadTime &&
    state.value.detail?.voucher?.voucherUploadTime !== "0"
    ? dayjs(parseInt(state.value.detail?.voucher?.voucherUploadTime)).format(
        "YYYY-MM-DD HH:mm"
      )
    : null;
});

const queryId = router.currentRoute.value.query.id;

async function fetchIntroductions() {
  const res = await axios.get(
    "https://config-cdn.qiandaoapp.com/linjie-web/2025-spring-festival-activities.json"
  );
  state.value.inTroductionHtmlLink = res.data.htmlInside;
}

async function fetchVoucherDesc() {
  const res = await axios.get(
    "https://config-cdn.qiandaoapp.com/congress/special_lottery.json"
  );
  voucherDesc.value = res.data.voucherDesc;
}

async function fetchDetail() {
  const res: any = await LotteryApi.getLotteryInfo({ id: queryId });
  state.value.detail = res.data;
  state.value.voucher = res.data.voucher?.voucher || "";
  state.value.text = res.data.voucher?.text || "";
  reachedDeadline.value = res.data.isArrivedCantJoinTime;
}

async function handleSubmit() {
  if (!queryId) {
    showToast("活动不存在");
    return;
  }
  if (!state.value.voucher) {
    showToast("请上传图片");
    return;
  }
  if (!state.value.text) {
    showToast("请输入链接");
    return;
  }
  loading.value = true;
  let res: any;
  if (!lastSubmitedTime.value) {
    res = await LotteryApi.joinEvent({
      lotteryId: queryId,
      voucher: state.value.voucher,
      text: state.value.text,
    });
  } else {
    res = await LotteryApi.updateVoucher({
      lotteryId: queryId,
      voucher: state.value.voucher,
      text: state.value.text,
    });
  }
  console.log(res);

  if (res.code === 0 || res.code === "0") {
    showToast("操作成功");
    localStorage.setItem("SHARE_PROVE_EDITED", "SHARE_PROVE_EDITED");
    fetchDetail();
    jb.navigateBackLinjie({
      action: "refresh",
      extraAction: "refresh",
    });
  } else {
    showToast(res.message);
  }
  setTimeout(() => {
    loading.value = false;
    closeToast();
  }, 2000);
}

async function handleUpload() {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/*";

  input.onchange = (e: any) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async () => {
      // 将 base64 格式的图片数据发送到服务器
      const formData = new FormData();
      formData.append("image", reader.result);
      showLoadingToast("上传中");
      const res: any = await ossUpload({ file, scene: "user-trade-v2.image" });
      closeToast();

      state.value.voucher = res.url;
    };
  };

  input.click();
}

function handlePreview() {
  showImagePreview({
    images: [state.value.voucher],
    closeable: true,
  });
}

function handleGotoIntroduction() {
  if (window.isInFlutter) {
    jb.navigateTo({
      url: `congress://hybrid?url=${encodeURIComponent(
        state.value.inTroductionHtmlLink
      )}`,
    });
  } else {
    window.location.href = state.value.inTroductionHtmlLink;
  }
}

const handleFocus = () => {
  console.log("focus");

  setTimeout(() => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth",
    });
  }, 700);
};

onMounted(() => {
  fetchIntroductions();
  fetchDetail();
  fetchVoucherDesc();
  setTitle("分享证明");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DuTheme), { name: "linjie" }, {
    default: _withCtx(() => [
      (_unref(lastSubmitedTime))
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(lastSubmitedTime)) + "已提交最新证明 ", 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(DuButton), {
              size: "mini",
              icon: "script-config",
              color: "primary",
              type: "text",
              onClick: handleGotoIntroduction
            }, {
              default: _withCtx(() => [
                _hoisted_6
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            (!state.value.voucher)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "upload-container-unupload",
                  onClick: handleUpload
                }, [
                  _createVNode(_unref(DuIcon), {
                    name: "plus-circle",
                    size: "8.533333333333333rem",
                    color: "#918B9F"
                  }),
                  _hoisted_8
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "upload-container-upload",
                  onClick: handlePreview
                }, [
                  _createElementVNode("img", {
                    src: state.value.voucher,
                    alt: "",
                    class: "upload-image"
                  }, null, 8, _hoisted_9),
                  _createElementVNode("div", {
                    class: "reupload-btn",
                    onClick: _withModifiers(handleUpload, ["stop","prevent"])
                  }, [
                    _createVNode(_unref(DuButton), {
                      icon: "upload",
                      size: "small",
                      color: "default",
                      type: "text"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_11
                      ]),
                      _: 1
                    })
                  ], 8, _hoisted_10)
                ]))
          ]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(voucherDesc.value), 1),
          _hoisted_13,
          _createElementVNode("div", {
            class: "link-container",
            onFocusCapture: handleFocus
          }, [
            _createVNode(_unref(DuTextarea), {
              placeholder: "请输入或粘贴原帖链接",
              value: state.value.text,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((state.value.text) = $event)),
              bordered: ""
            }, null, 8, ["value"])
          ], 32)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_unref(DuButton), {
            full: "",
            size: "large",
            color: "primary",
            onClick: handleSubmit,
            disabled: reachedDeadline.value,
            loading: loading.value
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(lastSubmitedTime) ? "确认更新" : "确认提交"), 1)
            ]),
            _: 1
          }, 8, ["disabled", "loading"])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})